import API_INTERFACE_URI from "../constants/uri.constants";
import baseService from "./service";
import {globalHeaders} from "../utilities/http";

function retryFfrNumber(ffrNumbers) {
    const ffrList = Array.isArray(ffrNumbers) ? ffrNumbers : [ffrNumbers];
    let retryParams = `filters=ffrNumber(${ffrList.join(",")})`;
    let url = API_INTERFACE_URI.RETRY_FFR;
    url = url + "?" + retryParams;
    return baseService.post(url, globalHeaders);
}

function cancelFfr(ffrNumbers) {
    const ffrList = Array.isArray(ffrNumbers) ? ffrNumbers : [ffrNumbers];
    let cancelParams = `filters=ffrNumber(${ffrList.join(",")})`;
    let url = API_INTERFACE_URI.CANCEL_FFR;
    url = url + "?" + cancelParams;
    return baseService.post(url, globalHeaders);
}

function getAddress(ffrNumber) {
    let params = `filters=ffrNumber(${ffrNumber})`;
    let url = API_INTERFACE_URI.FFR_ADDRESS;
    url = url + "?" + params;
    return baseService.get(url, globalHeaders);
}

function updateRetryFfrAddress(payload) {
    let url = API_INTERFACE_URI.UPDATE_RETRY_FFR_ADDRESS;
    return baseService.post(url, globalHeaders, payload);
}

export const RetryFFRService = {
    retryFfrNumber,
    cancelFfr,
    getAddress,
    updateRetryFfrAddress
};
